import styled from '@emotion/styled';
import { currencyFormatter, percentageFormatter } from '@dnhb/formatters';
import Box from '../../../../shared/layouts/Box';
import { Flex } from '../../../../shared/layouts';
import { keyframes } from '@emotion/react';

const visibilityAnimation = keyframes`
    0% { opacity: 85% }
    50% { opacity: 25% }
    100% { opacity: 85% }
`;

const Card = styled(Box)(({ theme }) => ({
  position: 'relative',
  boxShadow: theme.boxShadows.normal,
  borderRadius: theme.borderRadius,
  width: '100%',
  overflow: 'hidden',
  textAlign: 'center',
  '.header': {
    backgroundColor: theme?.colors?.primary,
    color: '#ffffff',
    padding: '4px',
    textAlign: 'center'
  },
  '.loading': {
    animation: `${visibilityAnimation} 2s infinite`,
    animationTimingFunction: 'ease-in-out'
  }
}));

const ResultCard = ({
  isLoading,
  nhg,
  fixed_rate_term,
  maximum_mortgage,
  interest_rate,
  gross_payment,
  net_payment,
  mortgage_provider_logo,
  mortgage_provider_name
}) => {
  return (
    <Card>
      <div className={'header'}>
        <b>{nhg ? 'Met NHG' : 'Zonder NHG'}</b>
      </div>
      <Flex
        p={'m'}
        flexDirection={'column'}
        alignItems={'center'}
        className={isLoading ? 'loading' : null}
      >
        <img
          height={'32px'}
          src={mortgage_provider_logo}
          alt={mortgage_provider_name}
        />
        <Box marginY={'m'}>
          <Box fontScale={'xl'}>
            <b>{currencyFormatter(maximum_mortgage)}</b>
          </Box>
          <span>
            {`o.b.v. ${percentageFormatter(interest_rate)} en ${fixed_rate_term} jaar rentevast`}
          </span>
        </Box>
        <div>
          Bruto maandlast: <b>{currencyFormatter(gross_payment)}</b>
        </div>
        <div>
          Netto maandlast: <b>{currencyFormatter(net_payment)}</b>
        </div>
      </Flex>
    </Card>
  );
};

Card.defaultProps = {
  maxWidth: 1024,
  bg: 'white',
  borderRadius: 4
};

export default ResultCard;
